import types from './types'
import axios from 'axios'

export default {

  reset ({ commit }) {
    commit(types.RESET)
  },

  async forgotPassword ({ commit }, { username }) {
    commit(types.FORGOT_PASSWORD.REQUEST)
    try {
      commit(types.FORGOT_PASSWORD.SUCCESS, await axios.post('/api/forgot_password', { username }))
    } catch (err) {
      commit(types.FORGOT_PASSWORD.FAILURE)
    } finally {
    }
  },
  async resetPassword ({ commit }, { token }) {
    commit(types.RESET_PASSWORD.REQUEST)
    try {
      commit(types.RESET_PASSWORD.SUCCESS, await axios.post(`/api/reset_password/${token}`))
    } catch (err) {
      commit(types.RESET_PASSWORD.FAILURE)
    } finally {
    }
  }
}
